<template>
<loader v-bind="{ loading }">
  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th>Software</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="version in versions.data" :key="version.id">
        <td>{{ `${version.software.name} - ${version.version_number} - ${version.update_version}` }}</td>
      </tr>
    </tbody>
  </table>
  <pager :pageable="versions" @nav="goToPage"/>
</loader>
</template>
<script>
import Paginator from '@/store/models/Paginator'
import { getPath } from '@/api/common'

export default {
  data: () => ({
    versions: new Paginator,
    loading: true,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
    this.loadVersions()
  },

  methods: {
    loadVersions() {
      getPath({
        path: 'api/super' + this.$route.fullPath
      }, ({data}) => {
        this.versions = data
        this.loading = false
      }, error => {})
    },
    runFilters() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search term.')
        return
      }
      this.$router.push({
        name: 'software-versions',
        params: {
          software: this.$route.params.software
        },
        query: this.filters
      })
    },
    clearFilters() {
      this.filters.search = ''
      this.$router.push({
        name: 'software-versions',
        params: {
          software: this.$route.params.software
        },
        query: this.filters
      })
    },
    goToPage(page) {
      this.$router.push(page)
    },
    updateCvesForVersion(version) {

    }
  },

  watch: {
    '$route': 'loadVersions'
  }
}
</script>